module.exports = __webpack_public_path__ + "img/mob_pla_logo.f11e7a8a.png";